import { Box, Typography, Paper } from '@mui/material';

type ButtonProps = {
  Text: string;
  URL: string;
  Target?: '_blank' | '_self';
};

type CardProps = {
  Heading: string;
  Description?: string;
  CardIcon?: any;
  ButtonIcon: any;
  Button?: ButtonProps;
};
export const HelpGuideCard = ({
  Heading,
  Description,
  CardIcon,
  ButtonIcon,
  Button
}: CardProps) => {
  return (
    <Paper
      sx={{
        p: 3,
        mt: 3,
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
        <Box sx={{ pr: 1 }}>
          <Typography color="primary.main" variant="body1" component={'h3'} sx={{ mb: 1 }}>
            {Heading}
          </Typography>
          {Description && (
            <Typography sx={{ mb: 2, flexGrow: 1 }} variant="body2">
              {Description}
            </Typography>
          )}
        </Box>

        {CardIcon && (
          <Box>
            <CardIcon sx={{ width: '2rem', height: '2rem', color: 'secondary.main' }} />
          </Box>
        )}
      </Box>
      <Box sx={{ display: 'flex', mt: 'auto', justifyContent: 'flex-end' }}>
        <a
          style={{ fontSize: '15px', fontWeight: 600, display: 'flex', alignItems: 'center' }}
          href={Button?.URL}
          target={Button?.Target}
        >
          {Button?.Text} {ButtonIcon && <ButtonIcon sx={{ ml: 1, fontSize: '20px' }} />}
        </a>
      </Box>
    </Paper>
  );
};
